import Region from "./Region.react"
import Section from "./Section.react"
import Column from "./Column.react"
import Field from "./Field.react"

const content = { Region, Column, Section, Field }
export default content
